module.exports = __webpack_public_path__ + "static/media/circle_2.5ec0263c.svg";